<template>
  <div class="user-info new-moudle">
    <div v-if="!isPcGame" :class="['user-info-item', canChangeAccount ? 'arrow-right-btn' : '']" @click="changeAccount">
      <span>游戏账号</span>
      <p class="user-info-os">{{ systemEnv }} {{ showQQNumber ? ` （${showQQNumber}）` : "" }}</p>
    </div>

    <slot name="editProvideUin"></slot>

    <div class="new-moudle user-info-item">
      <span>游戏分区</span>
      <p v-if="!selectAndCheckRole" class="user-info-area user-info--cells">
        <span class="checked-name">游戏预约期，无游戏分区</span>
      </p>
      <p v-else-if="!zoneName" class="user-info-area arrow-right-btn" @click="changeGameRoleZone">
        {{ userAgent.weixinminiprogram || fromMini ? "请选择QQ/微信大区" : "请选择游戏大区" }}
      </p>
      <p v-else class="user-info-area arrow-right-btn user-info--cells" @click="changeGameRoleZone">
        <span class="checked-name"> {{ zoneInfo }} </span>
        <i v-if="accountType === 'WX' && isMobileGame" class="user-info-way way--wx"></i>
        <i v-if="accountType === 'QQ' && isMobileGame" class="user-info-way way--qq"></i>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "zoneInfo",
    "isMobileGame",
    "accountType",
    "selectAndCheckRole",
    "isPcGame",
    "zoneName",
    "showQQNumber",
    "systemEnv",
    "userAgent",
    "fromMini",
    "changeLoginAccount"
  ],

  computed: {
    canChangeAccount() {
      if (this.changeLoginAccount) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    changeGameRoleZone() {
      this.$emit("changeGameRoleZone")
    },

    changeAccount() {
      this.changeLoginAccount && this.changeLoginAccount()
    }
  }
}
</script>
